export const NRP_ERROR_MESSAGES = {
	EMPTY_NRP: 'Escribe el Número de Registro Patronal (NRP) de la empresa.',
	INVALID_NRP: 'El Número de Registro Patronal debe tener 11 caracteres.',
};
